<template>
  <div class="home mt-5">
    <div class="text-center" v-if="accountStatus === 'PENDING'">
      Aguardando confirmação do pagamento. Se você já fez o pagamento, aguarde ou entre em contato.
    </div>
    <div v-if="accountStatus === 'INACTIVE'">
      <Payments />
    </div>
    <!-- <img alt="logo" src="../assets/logo.png"> -->

    <!-- Banner Bancada GenIA -->
    <b-container v-if="accountStatus === 'ACTIVE' || accountStatus === 'ONLY_TRIAL'">
      <div class="bancada-banner">
        <div class="bancada-banner-content">
          <div class="bancada-banner-icon">
            <i class="fa fa-map-signs"></i>
          </div>
          <div class="bancada-banner-text">
            <h5 class="bancada-banner-title">Bancada Previdenciária GenIA</h5>
            <p class="bancada-banner-subtitle">
              Comece pelo mapa para entender o fluxo, ou acesse uma especialista direto.
            </p>
          </div>
        </div>
        <router-link to="/bancada" class="btn bancada-banner-btn">
          <i class="fa fa-compass"></i>
          Quero ajuda para encontrar o caminho
        </router-link>
      </div>
    </b-container>

    <ListCustomers v-if="accountStatus === 'ACTIVE' || accountStatus === 'ONLY_TRIAL'" />
    <div class="d-flex justify-content-center mt-5">
      <div class="card-deck d-flex justify-content-center col-6 mb-3">
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import ListCustomers from '@/components/ListCustomers.vue';
import RequirementsChecklist from '@/components/RequirementsChecklist.vue';
import Payments from '@/components/Payments.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
    ListCustomers,
    RequirementsChecklist,
    Payments
  },
  computed: {
    ...mapGetters(['accountStatus']),
  }
}
</script>

<style scoped>
.bancada-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.bancada-banner-content {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.bancada-banner-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: #0b6baf;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.bancada-banner-title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  color: #1a202c;
}

.bancada-banner-subtitle {
  font-size: 0.875rem;
  color: #4a5568;
  margin: 0;
  margin-top: 2px;
}

.bancada-banner-btn {
  background: #f59e0b;
  color: #fff !important;
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.625rem 1.25rem;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.15s;
  white-space: nowrap;
}

.bancada-banner-btn:hover {
  background: #d97706;
  color: #fff !important;
  text-decoration: none;
}

.bancada-banner-btn i {
  margin-right: 6px;
}

@media (max-width: 575px) {
  .bancada-banner {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
  .bancada-banner-content {
    justify-content: center;
  }
  .bancada-banner-btn {
    width: 100%;
    text-align: center;
  }
}
</style>
